import React, {
  MouseEventHandler,
  ReactNode,
} from 'react';
import MuiRadio, {
  RadioProps,
} from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import clsx from 'clsx';

type Props = {
  className?: string;
  label?: ReactNode;
  value: string | boolean;
  checked?: boolean;
  disabled?: boolean;
  color?: 'primary' | 'secondary';
  size?: RadioProps['size'];
  classes?: RadioProps['classes'];
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export default function Radio({
  className,
  label,
  value,
  checked,
  disabled,
  color = 'primary',
  size,
  classes = {},
  onClick,
}: Props) {
  return (
    <FormControlLabel
      value={value}
      className={className}
      classes={{ root: '!mr-0' }}
      control={(
        <MuiRadio
          size={size}
          checked={checked}
          disabled={disabled}
          color={color}
          classes={{
            ...classes,
            root: clsx('!p-0', classes?.root),
          }}
          onClick={onClick}
        />
      )}
      label={label}
    />
  );
}
